
const HeroSection = () => {
  return (
    <section className="relative min-h-[70vh] flex items-center justify-center py-32 overflow-hidden">
      {/* Background with overlay */}
      <div className="absolute inset-0 z-0">
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: `url('https://public.readdy.ai/ai/img_res/d9a1c50afb18a77a62bfeccd9a42d5a2.jpg')`
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-r from-slate-900/80 via-slate-900/60 to-slate-900/40"></div>
      </div>

      {/* Animated particles */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/4 left-1/4 w-2 h-2 bg-blue-400 rounded-full animate-pulse"></div>
        <div className="absolute top-1/3 right-1/3 w-1 h-1 bg-cyan-400 rounded-full animate-ping"></div>
        <div className="absolute bottom-1/4 left-1/3 w-1.5 h-1.5 bg-teal-400 rounded-full animate-pulse"></div>
      </div>

      <div className="relative z-10 container mx-auto px-6 text-center max-w-5xl">
        <div className="inline-block mb-6">
          <span className="px-4 py-2 bg-blue-600/20 text-blue-300 rounded-full text-sm font-medium border border-blue-400/30">
            Our Story
          </span>
        </div>
        <h1 className="text-5xl md:text-6xl font-light text-white mb-6 leading-tight">
          About <strong className="bg-gradient-to-r from-blue-400 to-cyan-400 bg-clip-text text-transparent">Sentronics</strong>
        </h1>
        <p className="text-xl md:text-2xl text-blue-200 mb-8 font-light">
          Your Trusted Technology Partner Since 2015
        </p>
        <p className="text-lg text-white/80 leading-relaxed max-w-4xl mx-auto">
          Based in Hong Kong, we bridge the gap between cutting-edge technology and global markets, 
          delivering innovative solutions that drive business transformation and sustainable growth across industries.
        </p>
      </div>
    </section>
  );
};

export default HeroSection;
